import { render, staticRenderFns } from "./BatchPage.vue?vue&type=template&id=e280b7b2&"
import script from "./BatchPage.vue?vue&type=script&lang=js&"
export * from "./BatchPage.vue?vue&type=script&lang=js&"
import style0 from "./BatchPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e280b7b2')) {
      api.createRecord('e280b7b2', component.options)
    } else {
      api.reload('e280b7b2', component.options)
    }
    module.hot.accept("./BatchPage.vue?vue&type=template&id=e280b7b2&", function () {
      api.rerender('e280b7b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FinanceManage/VoucherMaintenance/BatchPage.vue"
export default component.exports